import { useState, useRef, useEffect } from "react";
import { OverlayViewF } from "@react-google-maps/api";
import CustomCSSTransition from "./CustomCSSTransition";
import MapBox from "../pages/findDietitian/MapBox";

const PriceOverlayView = ({
  center,
  currentPriceOverlayViewRef,
  setCurrentPriceOverlayViewRef,
  mapTo,
  setCenter,
}) => {
  const [zIndex, setZIndex] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const overlayViewRef = useRef(null);

  useEffect(() => {
    setIsActive(overlayViewRef === currentPriceOverlayViewRef);
  });

  useEffect(() => {
    setCenter(center);
  }, [zIndex]);

  const handleClick = () => {
    mapTo(center);
    setZIndex(9990);
    setCurrentPriceOverlayViewRef(overlayViewRef);
  };

  return (
    <OverlayViewF
      mapPaneName="floatPane"
      position={center}
      zIndex={isActive ? zIndex : 1}
    >
      <div className={`text-sm text-[#8b8b8b] relative`} ref={overlayViewRef}>
        <button
          className={`price font-extrabold text-sm transition-all duration-200 rounded-full px-3 pt-[2px] hover:scale-110 ${
            isActive ? "text-white bg-[#e66553] scale-110" : "bg-white"
          }`}
          onClick={handleClick}
        >
          $31
        </button>
      </div>
      <CustomCSSTransition inValue={isActive}>
        <MapBox
          isActive={isActive}
          setCurrentPriceOverlayViewRef={setCurrentPriceOverlayViewRef}
        />
      </CustomCSSTransition>
    </OverlayViewF>
  );
};

export default PriceOverlayView;
